// extracted by mini-css-extract-plugin
module.exports = {"rtbBanner":"FooterBanner_rtbBanner__C3jhd","rtbBanner_desktop":"FooterBanner_rtbBanner_desktop__MTpQ6","rtbBanner_mobile":"FooterBanner_rtbBanner_mobile__4OC92"};